import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import UIList from 'UIComponents/list/UIList';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { UNSUPPORTED_FILTER_TYPES, UNSUPPORTED_OPERATORS } from 'flow-doctor-lib/constants/Filters';
import { intersection } from 'flow-doctor-lib/utils/jsUtils';
import { getAllFilterTypesAndOperators } from 'flow-doctor-lib/utils/filterDissectionUtils';
import UILink from 'UIComponents/link/UILink';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { getFrameworkDataListUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnsupportedFilterTypeWarning = ({
  unsupportedFilterTypes,
  unsupportedOperators,
  mode
}) => {
  return /*#__PURE__*/_jsxs(Alert, {
    type: "warning",
    marginBlockEnd: "200",
    children: [unsupportedFilterTypes.size > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: mode === 'DIAGNOSIS' ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.unsupported.diagnosis.filterTypesDescription' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.unsupported.filterBranch.filterTypesDescription'
      }), /*#__PURE__*/_jsx(UIList, {
        className: "m-top-2",
        styled: true,
        children: Array.from(unsupportedFilterTypes).map(filterType => /*#__PURE__*/_jsx("span", {
          children: filterType
        }, filterType))
      })]
    }), unsupportedOperators.size > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: mode === 'DIAGNOSIS' ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.unsupported.diagnosis.operatorsDescription' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.unsupported.filterBranch.operatorsDescription'
      }), /*#__PURE__*/_jsx(UIList, {
        className: "m-top-2",
        styled: true,
        children: Array.from(unsupportedOperators).map(operator => /*#__PURE__*/_jsx("span", {
          children: operator
        }, operator))
      })]
    }), getIsInternal() && /*#__PURE__*/_jsx(UILink, {
      href: getFrameworkDataListUrl({
        portalId: PortalIdParser.get()
      }),
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.unsupported.frameworkDataLink'
      })
    })]
  });
};
const withHistoricalEvalUnsupportedFilters = WrappedComponent => {
  return props => {
    const {
      filterTypes: unsupportedFilterTypes,
      operators: unsupportedOperators
    } = React.useMemo(() => {
      const {
        filterTypes,
        operators
      } = getAllFilterTypesAndOperators(props.filterBranch);
      return {
        filterTypes: intersection(filterTypes, UNSUPPORTED_FILTER_TYPES),
        operators: intersection(operators, UNSUPPORTED_OPERATORS)
      };
    }, [props.filterBranch]);

    // Don't show alert if all filter types are supported
    if (unsupportedFilterTypes.size === 0 && unsupportedOperators.size === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      unsupportedFilterTypes: unsupportedFilterTypes,
      unsupportedOperators: unsupportedOperators
    }));
  };
};
export default withHistoricalEvalUnsupportedFilters(UnsupportedFilterTypeWarning);